<template>
  <!-- 按钮类型
       @author: 王汝鹏
       @date: 2019-9-15
   -->
  <div class="setting-item">
    <el-form-item label="按钮类型"> 
      <el-select v-model="buttonType" class="setting-button_type">
        <el-option v-for="item in buttonTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
        </el-option>
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
// 导入按钮类型配置数组
import { buttonTypeList } from '@/assets/js/config_dictionary.js';
export default {
  mixins: [ mixValueWatch ],
    data () {
        return {
            // 按钮类型配置数组
            buttonTypeList
        }
  },
  computed: {
    /** @name 按钮类型
     *  @description 将 buttonType 字段映射到当前 buttonType 计算属性
     *  @return {String}
     *  @author 王汝鹏
     *  @version 2019-09-10
     */
    ...mapComputed({
      buttonType: { 
        parent: i => i.baseOption,
        attr: "buttonType" 
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingButtonType.vue